
import { useState,useEffect } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDEditor from "components/MDEditor";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import {gapList, guestList, durationList, minorList, categoriesList } from "../../static_data"

// NewProduct page components
import FormField from "layouts/ecommerce/products/new-product/components/FormField";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
// import TextField from "@mui/material/TextField";

import { TextField } from "@mui/material";
import {useLocation} from "react-router-dom";
import AmenitiesService from "../../../../../../services/amenities.service";
import BookingLimitGroupCreateModal from "../../../../../../components/BookingLimitGroupCreateModal";



function AmenityInfo({validStep, uniqueId, oldValues, valueSetter, ...rest}) {

    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');


    // console.log('Hello', oldValues);
    const defaultInputValues = {
        amenityName:  oldValues['amenityName'] || '',
        minors: oldValues['minors'] || minorList[0],
        guests: oldValues['guests'] || guestList[0],
        duration : oldValues['duration'] || durationList[0],
        gap : oldValues['gap'] || gapList[0],
        category: oldValues['category'] || categoriesList[0],
        subCategory : '',
        capacity : "10",
        shared_resource: oldValues['shared_resource'] || null,
        booking_limit_group: oldValues['booking_limit_group'] || null,
        booking_limit_group_id: oldValues['booking_limit_group_id'] || null,
        booking_limit_group_name: oldValues['booking_limit_group_name'] || '',
        shared_resource_name: oldValues['shared_resource_name'] || '',
        shared_resource_capacity: oldValues['shared_resource_capacity'] || '',
        resource_layout: oldValues['resource_layout'] || '',
        resource_capacity_units: oldValues['resource_capacity_units'] || '',
        description : oldValues['description'] || "This is\nAmenity \nDescription"
      };

    const validationSchema = Yup.object().shape({
         amenityName: Yup.string()
              .min(3, 'Amenity Name must be at least 3 characters')
              .required('Amenity Name is required'),
          minors: Yup.number().required("minors is required").nullable(false),
          guests: Yup.number().required("guests is required").nullable(false),
          duration: Yup.string().required("duration is required ").nullable(false),
          gap: Yup.string().required("gap is required ").nullable(false),
          // category: Yup.string().required("category is required"),
          description: Yup.string(),
          capacity: Yup.string(),
      });



    const [values, setValues] = useState(defaultInputValues);
    const [sharedResources, setSharedResources] = useState([]);
    const [bookingLimitGroups, setBookingLimitGroups] = useState([]);
    const [groupSearch, setGroupSearch] = useState(oldValues.booking_limit_group_name || "");
    const [showCreateGroup, setShowCreateGroup] = useState(false);
    const [editingGroup, setEditingGroup] = useState(null);
    const [newGroupName, setNewGroupName] = useState("");
    const [resourceLayouts, setResourceLayouts] = useState([]);
    const { register, handleSubmit, formState: { errors , isValid } } =
                        useForm({mode:"all", resolver:yupResolver(validationSchema)});
    const handleChange = (value) => {
        setValues(value)
        valueSetter(prev => ({ ...prev, ...value }))
    };
    const selectBookingLimitGroup = (group) => {
        setGroupSearch(group?.name || "");
        handleChange({ ...values,
          booking_limit_group: group || null,
          booking_limit_group_id: group?.id || null,
          booking_limit_group_name: group?.name || "",
          ...(group ? {
            max_future_bookings_per_unit: String(group.max_future_bookings_per_unit),
            max_daily_bookings_per_user: String(group.max_daily_bookings_per_user),
          } : {}),
        });
    };




    useEffect(() => {
        AmenitiesService.getAmenitySharedResources()
          .then(response => setSharedResources(response.data || []))
          .catch(() => setSharedResources([]));
        AmenitiesService.getAmenityBookingLimitGroups()
          .then(response => setBookingLimitGroups(response.data || []))
          .catch(() => setBookingLimitGroups([]));
        AmenitiesService.getAmenityResourceLayouts()
          .then(response => setResourceLayouts(response.data || []))
          .catch(() => setResourceLayouts([]));

        if(id === null || id === undefined || id === "0" || id === 0){
             console.log("new amenity")
        }else{
          console.log("edit amenity, id:", id)
            AmenitiesService.getAmenityInfo(id)
              .then(value => {
                  const data = value.data;
                  console.log("Fetched amenity data:", data)
                  let customData = {
                      'id': data["id"],
                      'image': data["image"] ? data["image"].toString() : '',
                      'amenityName': data["name"] ? data["name"].toString() : '',
                      'description': data["description"] ? data["description"].toString() : '',
                      'gap': data["gap_duration"] ? data["gap_duration"].toString() + " Minutes" : "15 Minutes",
                      'duration': data["period_duration"] ? data["period_duration"].toString() + " Minutes" : "30 Minutes",
                      'guests': data["guests_count"] ? data["guests_count"].toString() : "0",
                      'minors': data["minors_count"] ? data["minors_count"].toString() : "0",
                      'capacity': data["all_capacity"] ? data["all_capacity"].toString() : "10",
                      'category': data["amenity_type"] || null,
                      'shared_resource': data["shared_resource_id"] ? data["shared_resource"] : null,
                      'booking_limit_group': data["booking_limit_group_id"] ? data["booking_limit_group"] : null,
                      'booking_limit_group_id': data["booking_limit_group_id"] || null,
                      'booking_limit_group_name': data["booking_limit_group"]?.name || '',
                      'max_future_bookings_per_unit': String(data["booking_limit_group_id"] ? data["booking_limit_group"]?.max_future_bookings_per_unit : data["max_future_bookings_per_unit"] ?? '3'),
                      'max_daily_bookings_per_user': String(data["booking_limit_group_id"] ? data["booking_limit_group"]?.max_daily_bookings_per_user : data["max_daily_bookings_per_user"] ?? '2'),
                      'shared_resource_id': data["shared_resource_id"] || null,
                      'shared_resource_name': data["shared_resource"]?.name || '',
                      'shared_resource_capacity': data["shared_resource"]?.capacity ? data["shared_resource"].capacity.toString() : '',
                      'resource_layout': data["resource_layout"] || '',
                      'resource_capacity_units': data["resource_capacity_units"] ? data["resource_capacity_units"].toString() : '',
                      'price': data["price"] ? data["price"].toString() : "0",
                      'unit': data["currency"] ? data["currency"].toString() : "CAD",
                  }
                  console.log("Transformed customData:", customData);
                  setGroupSearch(customData.booking_limit_group_name);
                  handleChange(customData);
                  validStep(validationSchema.isValidSync(customData));
              }).catch(reason => {
                  console.error("Error fetching amenity:", reason);
              });
        }
    },[id])

    // console.log();
    validStep(validationSchema.isValidSync(values));
    // console.log("errors -> " + isValid + "," + )
  return (
    <MDBox>
      <MDTypography variant="h5">Amenity Information</MDTypography>
      <MDBox mt={3} component={"form"} >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={8} >
              <TextField
                  type="text"
                  label="Amenity Name"
                  required
                  variant={"standard"}
                  fullWidth
                  name="amenityName"
                  error={!!errors.amenityName}
                  helperText={errors.amenityName?.message}
                  value={values.amenityName}
                  {...register("amenityName")}
                  onChange={(event) =>
                      handleChange({ ...values, amenityName: event.target.value })}

              />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              options={minorList}
              value={values.minors}
              onChange={(event,value) =>
                  handleChange({ ...values, minors: value })}
              renderInput={(params) =>
                  <MDInput {...params} label={"Minors"}
                           variant="standard"
                           error={!!errors.minors}
                           helperText={errors.minors?.message}
                           {...register("minors")} />}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              options={guestList}
              value={values.guests}
              onChange={(event,value) =>
                  handleChange({ ...values, guests: value })}
              renderInput={(params) =>
                  <MDInput {...params} label={"Guest"} variant="standard"
                           error={!!errors.guests}
                           helperText={errors.guests?.message}
                           {...register("guests")}
                  />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              options={durationList}
              value={values.duration}
              onChange={(event,value) =>
                  handleChange({ ...values, duration: value })}
              renderInput={(params) =>
                  <MDInput {...params} label={"Duration"} variant="standard"
                           error={!!errors.duration}
                           helperText={errors.duration?.message}
                           {...register("duration")}
                  />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              options={gapList}
              value={values.gap}
              onChange={(event,value) =>
                  handleChange({ ...values, gap: value })}
              renderInput={(params) =>
                  <MDInput {...params} label={"Gap"} variant="standard"
                           error={!!errors.gap}
                           helperText={errors.gap?.message}
                           {...register("gap")}
                  />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField value={values.capacity} type={"number"} name="capacity" label="Capacity" fullWidth required
                  variant={"standard"}
                      onChange={(e)=>{
                          handleChange({ ...values, capacity: e.target.value }) }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDBox mt={1} p={2.5} borderRadius="lg" border="1px solid #d7dce5" bgcolor="#fbfcff">
              <MDTypography variant="h6" fontWeight="medium">Booking limit group (optional)</MDTypography>
              <MDTypography variant="caption" color="text">
                Amenities in the same group share the future per-unit and daily per-person booking limits.
                Select an existing group or type a name and choose Add group to set its limits.
              </MDTypography>
              <Autocomplete
                options={bookingLimitGroups}
                value={values.booking_limit_group || null}
                inputValue={groupSearch}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                getOptionLabel={(option) => option?.inputValue ? `Add group "${option.inputValue}"` : option?.name || ''}
                filterOptions={(options, { inputValue }) => {
                  const name = inputValue.trim();
                  const filtered = options.filter(option => option.name.toLowerCase().includes(name.toLowerCase()));
                  if (name && !options.some(option => option.name.toLowerCase() === name.toLowerCase())) {
                    filtered.push({ inputValue: name, name: `Add group "${name}"` });
                  }
                  return filtered;
                }}
                onInputChange={(event, name, reason) => {
                  if (reason === 'input') {
                    setGroupSearch(name);
                    if (values.booking_limit_group_id) {
                      handleChange({ ...values, booking_limit_group: null, booking_limit_group_id: null, booking_limit_group_name: '' });
                    }
                  }
                }}
                onChange={(event, option) => {
                  if (option?.inputValue) {
                    setEditingGroup(null);
                    setNewGroupName(option.inputValue);
                    setShowCreateGroup(true);
                  } else {
                    selectBookingLimitGroup(option);
                  }
                }}
                renderInput={(params) => <MDInput {...params} label="Booking limit group" variant="standard" />}
              />
              {values.booking_limit_group_id && <MDButton type="button" variant="text" color="info" sx={{ mt: 1 }}
                onClick={() => {
                  setEditingGroup(values.booking_limit_group);
                  setShowCreateGroup(true);
                }}>Edit group limits</MDButton>}
            </MDBox>
          </Grid>
          <Grid item xs={12}>
            <MDBox
              mt={1}
              p={2.5}
              borderRadius="lg"
              border="1px solid #d7dce5"
              bgcolor="#fbfcff"
            >
              <MDBox mb={1.5}>
                <MDTypography variant="h6" fontWeight="medium">
                  Shared Resource Rules
                  <MDTypography component="span" variant="caption" color="text" fontWeight="regular">
                    &nbsp;(optional)
                  </MDTypography>
                </MDTypography>
                <MDTypography variant="caption" color="text">
                  Fill this section only when this amenity shares the same physical space with other amenities.
                  Leave it empty for normal amenities that do not affect each other.
                </MDTypography>
              </MDBox>
              <Grid container spacing={3} mt={0.5}>
                <Grid item xs={12} sm={4}>
                  <Autocomplete
                    freeSolo
                    options={sharedResources}
                    value={values.shared_resource || values.shared_resource_name || null}
                    getOptionLabel={(option) => {
                      if (typeof option === "string") return option;
                      return option?.name || "";
                    }}
                    onInputChange={(event, value) => {
                      if (event) {
                        handleChange({ ...values, shared_resource: null, shared_resource_id: null, shared_resource_name: value });
                      }
                    }}
                    onChange={(event, value) => {
                      if (typeof value === "string") {
                        handleChange({ ...values, shared_resource: null, shared_resource_id: null, shared_resource_name: value });
                      } else {
                        handleChange({
                          ...values,
                          shared_resource: value,
                          shared_resource_id: value?.id || null,
                          shared_resource_name: value?.name || "",
                          shared_resource_capacity: value?.capacity ? value.capacity.toString() : values.shared_resource_capacity,
                        });
                      }
                    }}
                    renderInput={(params) =>
                      <MDInput {...params} label={"Shared Resource"} variant="standard" />
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    value={values.shared_resource_capacity}
                    type={"number"}
                    name="shared_resource_capacity"
                    label="Resource Capacity"
                    fullWidth
                    variant={"standard"}
                    onChange={(e)=> handleChange({ ...values, shared_resource_capacity: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Autocomplete
                    freeSolo
                    options={resourceLayouts}
                    value={values.resource_layout || null}
                    onInputChange={(event, value) => {
                      if (event) {
                        handleChange({ ...values, resource_layout: value });
                      }
                    }}
                    onChange={(event, value) => {
                      handleChange({ ...values, resource_layout: value || "" });
                    }}
                    renderInput={(params) =>
                      <MDInput
                        {...params}
                        label={"Resource Layout"}
                        placeholder="tennis / pickleball / badminton"
                        variant="standard"
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    value={values.resource_capacity_units}
                    type={"number"}
                    name="resource_capacity_units"
                    label="Units Used"
                    fullWidth
                    variant={"standard"}
                    onChange={(e)=> handleChange({ ...values, resource_capacity_units: e.target.value })}
                  />
                </Grid>
              </Grid>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={12}>
            <MDBox mb={2} display="inline-block">
              <MDTypography
                component="label"
                variant="button"
                fontWeight="regular"
                color="text"
                textTransform="capitalize"
              >
                Category
              </MDTypography>
            </MDBox>
            <Autocomplete
              options={categoriesList}
              value={values.category}
              clearIcon={false}

              contentEditable={false}
              onChange={(e,value)=>{
                handleChange({ ...values, category: value })
              }}
              getOptionLabel={(label)=>label.amenity_type}
              renderInput={(params) =>
                  <MDInput {...params}
                           error={!!errors.category}
                           helperText={errors.category?.message}
                            {...register("category")}
                  />
              }
            />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                Description&nbsp;&nbsp;
                <MDTypography variant="caption" color="text">
                  (optional)
                </MDTypography>
              </MDTypography>
            </MDBox>
            <TextField value={values.description}
                        name="description"
                       fullWidth
                      required
                       multiline={true}
                      onChange={(e)=>{
                          handleChange({ ...values, description: e.target.value }) }}
            />
          </Grid>
        </Grid>
      </MDBox>
      <BookingLimitGroupCreateModal open={showCreateGroup} group={editingGroup} initialName={newGroupName}
        onClose={() => setShowCreateGroup(false)}
        onCreated={(group) => {
          setBookingLimitGroups((current) => editingGroup?.id
            ? current.map((item) => item.id === group.id ? group : item)
            : [...current, group]);
          selectBookingLimitGroup(group);
          setShowCreateGroup(false);
          setEditingGroup(null);
        }} />
    </MDBox>
  );
}

export default AmenityInfo;
